import { useNavigate } from 'react-router-dom'
import { Table } from 'reactstrap'
import { enterKeyHandler, setSessionStorage } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import CustomSelectListInput from '../CustomSelectListInput'
import { initialFormValues, stringifyInputs } from '../CustomUtils'
import FormHeading from '../FormHeading'
import FormSubmitButton from '../FormSubmitButton'

export default function ClaimCountsByStateForm({ location }) {
  console.log('ClaimCountsByStateForm rendered: ', location)

  let init = {
    plaintiffStatus: [],
    courtType: [],
    plaintiffCounsel: []
  }

  const navigate = useNavigate()
  init = initialFormValues('ClaimCountsByStateForm', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))

  async function submitSearch() {
    console.log('ClaimCountsByStateForm.submitSearch', inputs)
    setSessionStorage('ClaimCountsByStateForm', JSON.stringify(inputs))
    let queryString = `/custom/claim_count_by_report?inputs=${stringifyInputs(inputs)}&reportType=S`
    navigate(queryString)
  }

  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit} style={{ maxWidth: '700px', margin: '20px auto' }}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{ backgroundColor: 'white' }}>
            <FormHeading headingText="Summary of Claims by Current Diagnosis and State" />
            <tbody>
              <CustomSelectListInput label="Plaintiff Status" handleChange={handleInputChange} modelName="Asbestos" entityName="plaintiff_status" name='plaintiffStatus' multiple={true} defaultValue={inputs.plaintiffStatus} />
              <CustomSelectListInput label="Court Type" className="custom-input" handleChange={handleInputChange} modelName="Asbestos" entityName="court_level" name='courtType' multiple={true} defaultValue={inputs.courtType} />
              <CustomSelectListInput label="Plaintiff Counsel" className="custom-input" handleChange={handleInputChange} modelName="Asbestos" entityName="opposing_firm" name='plaintiffCounsel' multiple={true} defaultValue={inputs.plaintiffCounsel} />
            </tbody>
          </Table>
        </div>
        <FormSubmitButton />
      </form>
    </div>
  )
}

